import type { Transaction } from '@/lib/transactions/types';

export type CategoryDetailFilterTarget =
  | { kind: 'parent'; categoryId: string }
  | { kind: 'child'; categoryId: string };

export function nextSelectedSubcategoryId(
  currentId: string | null,
  clickedId: string,
): string | null {
  return currentId === clickedId ? null : clickedId;
}

export function resolveCategoryDetailFilterTarget(
  parentCategoryId: string | null,
  selectedSubcategoryId: string | null,
): CategoryDetailFilterTarget | null {
  if (!parentCategoryId) return null;
  return selectedSubcategoryId
    ? { kind: 'child', categoryId: selectedSubcategoryId }
    : { kind: 'parent', categoryId: parentCategoryId };
}

export function filterTransactionsBySelectedSubcategory<T extends Transaction>(
  txs: readonly T[],
  parentCategoryId: string | null,
  selectedSubcategoryId: string | null,
): T[] {
  if (!parentCategoryId || !selectedSubcategoryId) return [...txs];
  return txs.filter((tx) => {
    const parent = tx.parentCategoryId ?? tx.categoryId;
    return parent === parentCategoryId && tx.categoryId === selectedSubcategoryId;
  });
}
